import {
  getModuleTranslator,
  getRootPluaralTranslator,
} from '@utils/get-module-translator'
import { generateId } from '@utils/id'
import moduleConfig from '../../config'

const __tc = getRootPluaralTranslator()
const __mtc = getModuleTranslator(moduleConfig.translationKey)

export const softwareProperyFieldMap = () => ({
  software_property_group: {
    title: __mtc('software_property_group'),
    fields: [
      {
        key: generateId(),
        paramName: 'softwareCost',
        name: __tc('software_cost'),
        inputType: 'number',
        currency: 'currencyId',
      },
      {
        key: generateId(),
        paramName: 'lastAuditDate',
        name: __tc('last_audit_date'),
        inputType: 'date',
      },
      {
        key: generateId(),
        paramName: 'executableFileNames',
        name: `${__mtc('executable_file_names')}`,
        inputType: 'tags',
      },
    ],
  },
})
